type TabStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>
const KEY = 'rize-os.platform-costs.signed-out'

export class PlatformSessionGate {
  blocked: boolean
  revision = 0
  private storage: TabStorage
  constructor(storage: TabStorage) {
    this.storage = storage
    try { this.blocked = storage.getItem(KEY) === 'true' } catch { this.blocked = true }
  }
  close(): number {
    this.blocked = true
    this.revision++
    try { this.storage.setItem(KEY, 'true') } catch { return this.revision }
    return this.revision
  }
  passwordSucceeded(revision: number): boolean {
    if (revision !== this.revision) return false
    // If tab persistence cannot be cleared, fail closed rather than publishing
    // a session that would contradict the signed-out intent on the next reload.
    try { this.storage.removeItem(KEY) } catch { return false }
    this.blocked = false
    return true
  }
  invalidate(): void { this.revision++ }
}
